interface RuntimeConfig {
  deliveryMapBaseUrl?: string;
  apiBaseUrl?: string;
  fileApiBaseUrl?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

const runtimeConfig = window.__APP_CONFIG__ ?? {};

export const API_BASE_URL = runtimeConfig.apiBaseUrl
  ?? process.env.REACT_APP_API_BASE_URL
  ?? 'http://api.admin.vitego.localhost';
export const FILE_API_BASE_URL = runtimeConfig.fileApiBaseUrl
  ?? process.env.REACT_APP_FILE_API_BASE_URL
  ?? 'http://api.vitego.localhost';
